/**
 * 灵犀统计
 */

class Analytics {
  private readonly commonParams = {
    // 目前没有utmSource，暂时用-999代替
    utm_source: '-999'
  };
  constructor() {
    // empty
  }

  pv(cid: any, lab = {}) {
    if ('LXAnalytics' in window && cid) {
      (window as any).LXAnalytics(
        'pageView',
        {
          custom: {
            ...this.commonParams,
            ...lab
          }
        },
        cid
      );
    }
  }
  mv(bid: any, lab = {}) {
    if ('LXAnalytics' in window && bid) {
      (window as any).LXAnalytics('moduleView', bid, {
        ...this.commonParams,
        ...lab
      });
    }
  }
  click(bid: any, lab = {}, tagConfig?: { key: string; cid: string }) {
    if ('LXAnalytics' in window && bid) {
      if (tagConfig) {
        const category = tagConfig.key || 'pay';
        const cid = tagConfig.cid || '';
        (window as any).LXAnalytics('tag', category, {
          [cid]: {
            bid,
            ...lab
          }
        });
      }
      (window as any).LXAnalytics('moduleClick', bid, {
        ...this.commonParams,
        ...lab
      });
    }
  }

  setName(appnm: string) {
    if ('LXAnalytics' in window && appnm) {
      (window as any).LXAnalytics('set', 'appnm', appnm);
    }
  }
}
export const analytics = new Analytics();
